import styled from "styled-components/macro";

export const Container = styled.div`
  position: absolute;
  border: 2px solid var(--primary-cta);
  border-radius: 4px;

  /* set to -1 so that it goes below all selected cards */
  z-index: -1;

  background: transparent;
`;
